import { algolia } from 'lc-services/services/algolia'

// The boundaries of Le Collectionist global search results
export const DEFAULT_COORDINATES_BOUNDARIES = [
  [-62.868266810171775, 17.530443789546954],
  [25.869799056014344, 49.40415631511685],
] as [number, number][]

export const getDestinationHousesCount = ({
  config,
  query,
  filters,
}: {
  config: any
  query: string
  filters?: string
}) => {
  const defaultFilter = 'NOT houses_count=0 AND NOT state:hidden'

  return algolia({
    apiKey: config.public.algoliaSearchKey,
    appId: config.public.algoliaId,
    prefix: config.public.algoliaIndexPrefix,
  }).simpleQuery<{ houses_count: number; id: string }>({
    indexName: 'public_destinations',
    query: query,
    params: {
      attributesToRetrieve: ['houses_count', 'id'],
      hitsPerPage: 20,
      responseFields: ['hits'],
      filters: filters?.length ? filters : defaultFilter,
    },
  })
}

export const fromInsideBoundingBoxToCoordinatesBoundaries = (
  input?: [number[]],
): false | { min_coords: [number, number]; max_coords: [number, number] } =>
  input?.[0].length === 4 && {
    min_coords: [input[0][1], input[0][0]],
    max_coords: [input[0][3], input[0][2]],
  }

export const fromCoordinatesToBoundaries = (
  coords?: number[],
  distanceInMeters = 200000,
) => {
  if (!coords?.length || coords.length !== 2) return null

  const { neLat, neLng, swLat, swLng } = buildBoundingBox(
    coords,
    distanceInMeters / 1000,
  )
  return {
    min_coords: [neLng, neLat] as [number, number],
    max_coords: [swLng, swLat] as [number, number],
  }
}
